import React, { useContext } from 'react'
import { DecisionBox, Loader, Responder } from 'src/component'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import {Notifier} from 'react-pop-notifier';

export const PopUps: React.FC<any> = () => {
    const { visibility: {isLoading, response, decision}  } = useContext(VisibilityContext)

    return (
        <>
            { isLoading ? <Loader /> : null }
            <Notifier />
            { response.status ? <Responder /> : null}
            {decision.status ? <DecisionBox /> : null}
        </>
    )
}